import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Home, Plane, FileText, Receipt as ReceiptIcon, Menu } from 'lucide-react';

const tabs = [
  { to: '/app/home', label: 'Home', icon: Home },
  { to: '/app/relocations', label: 'Pets', icon: Plane },
  { to: '/app/invoices', label: 'Invoices', icon: FileText },
  { to: '/app/receipts', label: 'Receipts', icon: ReceiptIcon },
  { to: '/app/more', label: 'More', icon: Menu },
];

export const BottomNav = () => {
  const location = useLocation();

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-40 pb-safe"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      data-testid="app-bottom-nav"
    >
      <div className="grid grid-cols-5">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = location.pathname.startsWith(tab.to);
          return (
            <NavLink
              key={tab.to}
              to={tab.to}
              className={`flex flex-col items-center justify-center py-2 px-1 gap-0.5 min-h-14 transition-colors ${
                isActive ? 'text-teal-600' : 'text-gray-500 active:bg-gray-50'
              }`}
              data-testid={`nav-${tab.label.toLowerCase()}`}
            >
              <Icon className={`w-5 h-5 ${isActive ? 'scale-110' : ''} transition-transform`} />
              <span className={`text-[11px] ${isActive ? 'font-semibold' : ''}`}>
                {tab.label}
              </span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};
